!function($) {

  // Add custom JavasScript here
  // --------------------------

  /* ------------------------------------------------------------------
     AJAX ADD TO CART  --  added by Claude on 2026-08-24 at the
     merchant's request (Joe Marco / Headlight Restore US).

     WHY
     The product form posts to /cart/add as a normal full-page
     navigation. Shopify only emits its "product_added_to_cart" Web
     Pixel event from the Ajax Cart API (/cart/add.js), so with the
     classic POST the Meta / GA4 AddToCart event was never sent.
     Events Manager showed AddToCart 12 vs InitiateCheckout 51 --
     impossible unless most add-to-carts were being lost.

     WHAT
     Intercepts the submit, adds the item through /cart/add.js so the
     pixel event fires, then sends the customer to /cart -- the same
     destination and the same number of clicks as before. The customer
     sees no difference.

     TIMING
     Measured on this store 2026-08-24: the tracking beacons are issued
     27-132 ms after the /cart/add.js response. PIXEL_GRACE_MS below is
     set to 400 ms, roughly a 3x margin, so the events are already in
     flight before the browser leaves the page. Once issued they survive
     the navigation.

     SAFETY
     Any failure (network error, non-200 response, timeout) falls back
     to the original native form submit, so the purchase path can never
     break.
     ------------------------------------------------------------------ */
  (function () {
    'use strict';

    var ADD_URL        = '/cart/add.js';
    var CART_URL       = '/cart';
    var PIXEL_GRACE_MS = 400;   // let the web-pixel beacons leave before navigating
    var TIMEOUT_MS     = 6000;  // after this, give up and submit natively
    var busy           = false;

    // Very old browser: leave the original behaviour completely alone.
    if (!window.fetch || !window.FormData) { return; }

    function isAddToCartForm(form) {
      return !!form && form.tagName === 'FORM' &&
             (form.getAttribute('action') || '').indexOf('/cart/add') !== -1;
    }

    function submitNatively(form) {
      // HTMLFormElement.prototype.submit() does not fire a submit event,
      // so this can never loop back into the handler below.
      HTMLFormElement.prototype.submit.call(form);
    }

    function isPaymentButton(el) {
      if (!el) { return false; }
      if (el.name === 'checkout') { return true; }
      return !!(el.closest && el.closest('.shopify-payment-button'));
    }

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!isAddToCartForm(form)) { return; }

      // Leave Shopify's dynamic checkout / Shop Pay buttons to do their own thing.
      if (isPaymentButton(e.submitter || document.activeElement)) { return; }

      e.preventDefault();
      if (busy) { return; }
      busy = true;

      var settled = false;

      var timer = setTimeout(function () {
        if (settled) { return; }
        settled = true;
        submitNatively(form);
      }, TIMEOUT_MS);

      fetch(ADD_URL, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(function (res) {
        if (!res.ok) { throw new Error('cart/add.js returned ' + res.status); }
        return res.json();
      })
      .then(function () {
        if (settled) { return; }
        settled = true;
        clearTimeout(timer);
        setTimeout(function () { window.location.href = CART_URL; }, PIXEL_GRACE_MS);
      })
      .catch(function () {
        if (settled) { return; }
        settled = true;
        clearTimeout(timer);
        busy = false;
        submitNatively(form);
      });
    }, true);
  }());

  // Document ready
  $(function() {


  });

}(jQuery);
